import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTypedTranslation } from '@app/hooks';
import { setExceptionHandler } from '@app/store/actions';
import { vaultGroupsService } from '@app/services';
import { IVaultGroup } from '@app/models';

export interface IReceivedData {
    vaultId: string;
    vaultName: string;
    vaultType: string;
    isIndividual: boolean;
    folderCount: number;
    passwordCount: number;
}

const VaultExtraDetailsComponent = (props: IReceivedData) => {
    const dispatch = useDispatch();
    const { translation } = useTypedTranslation();

    const [groupNames, setGroupNames] = useState('');

    useEffect(() => {
        dispatch(setExceptionHandler(true));

        // get group names
        vaultGroupsService.getVaultGroups(
            props.vaultId,
            'DisplayName',
            'asc',
            50,
            0,
            true
        )
            .then((response: any) => {
                const groups: IVaultGroup[] = response.data.value;
                let groupNamesConcat: string = '';

                groups.forEach(function (group: IVaultGroup) {
                    groupNamesConcat += group.DisplayName + ', ';
                });

                if (groupNamesConcat !== '') {
                    groupNamesConcat = groupNamesConcat.slice(0, -2);
                }
                else {
                    groupNamesConcat = translation('NONE');
                }

                setGroupNames(groupNamesConcat);
            })
            .catch(() => {
            });
    }, []);

    return (
        <>
            <div className='split-table'>
                <div className='vault-extra-details__heading'>
                    {props.vaultType} {translation('VAULT_LOWERCASE')}
                </div>
                <div className='split-table__body'>
                    {!props.isIndividual &&
                        <div className='split-table__row'>
                            <div className='split-table__cell split-table__cell--label'>{translation('POLICIES_USAGE')}:</div>
                            <div className='split-table__cell'>{groupNames}</div>
                        </div>
                    }
                    <div className='split-table__row'>
                        <div className='split-table__cell--label split-table__cell--label'>{translation('VAULT_FOLDER_TAB')}:</div>
                        <div className='split-table__cell'>{props.folderCount}</div>
                    </div>
                    <div className='split-table__row'>
                        <div className='split-table__cell--label split-table__cell--label'>{translation('VAULT_PASSWORDS_TAB')}:</div>
                        <div className='split-table__cell'>{props.passwordCount}</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VaultExtraDetailsComponent;